export function toPositiveIntOrNull(rawValue: unknown): number | null {
    const normalizedValue = Number(rawValue);
    return Number.isInteger(normalizedValue) && normalizedValue > 0 ? normalizedValue : null;
}

export function toNonNegativeIntOrNull(rawValue: unknown): number | null {
    const normalizedValue = Number(rawValue);
    return Number.isInteger(normalizedValue) && normalizedValue >= 0 ? normalizedValue : null;
}
